import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { useState } from "react";

import styled from "styled-components";

import PlanCard from "./components/PlanCard";
import Overview from "./components/Overview";
import PlanMembers from "./components/PlanMembers";
import Box from "../../components/Box/Box";
import Loader from "../../components/Loader2";

import { showNotification } from "../../util/Utility";
import { fetchUserDashboardStats } from "../../redux/UserReducer/userAction";
import OverviewMembers from "./components/OverviewMembers";
import DonationGraph from "./components/DonationGraph";

const RightSide = styled.div`
  background: #faf4fd;
`;

const Dashboard = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [dashboardWidgets, setDashboardWidgets] = useState([]);
  const activeEntity = useSelector((state) => state.adminReducer.activeEntity);
  const userType = useSelector((state) => state?.appReducer?.userType);
  const config = useSelector((state) => state?.appReducer?.pages);
  const dashboardStats = useSelector(
    (state) => state.userReducer?.dashboardStats
  );

console.log('dashboard stats', dashboardStats);

  useEffect(() => {
    if (dashboardStats) {
      const dashboardData = config?.find((data) => data?.label === "dashboard");
      setDashboardWidgets(dashboardData?.widgets[0]);
    }
  }, [dashboardStats]);

  useEffect(() => {
    if (userType === "product_owner") {
      setLoading(true);
      dispatch(fetchUserDashboardStats(null, userType))
        .then(() => setLoading(false))
        .catch(() => setLoading(false));
    } else if (userType && activeEntity?._id) {
      setLoading(true);
      dispatch(fetchUserDashboardStats(activeEntity._id, userType))
        .then(() => setLoading(false))
        .catch(() => setLoading(false));
    }
  }, [userType, activeEntity?._id]);

  return (
    <div>
      <RightSide>
        {loading ? (
          <Box>
            <Loader color="primary" />
          </Box>
        ) : (
          <>
            <div>
              <PlanCard
                widgets={dashboardWidgets}
                data={dashboardStats}
                role={userType}
              />
            </div>
            <div className={`${(userType === "admin" || userType === "viewer") ? "pt-4" : ""} row`}>
              {dashboardWidgets?.incomeOverview && (
                <Overview widgets={dashboardWidgets}/>
              )}
              {dashboardWidgets?.showTotalMembersChart && (
                <PlanMembers stats={dashboardStats} role={userType} />
              )}
              {dashboardWidgets?.showMemberOverviewChart && (
                <OverviewMembers stats={dashboardStats} role={userType} />
              )}
              {dashboardWidgets?.showDonationGraph && (
                <div className="mt-4 col-12">
                  <DonationGraph />
                </div>
              )}
            </div>
          </>
        )}
      </RightSide>
    </div>
  );
};

export default Dashboard;
